export const CONNECT_AND_OPTIMIZE_POINTS: string[] = [
  'Optimize all the images on your homepage',
  'Your homepage will get a 90+ Page Speed score',
  'Add and optimize more images and pages from your 10Web dashboard'
]
